import React from "react";
import "../style/Section5.scss";
import SectionTitle from "../components/SectionTitle";

function Section5(props) {
  return (
    <div id={"Section5"}>
      <SectionTitle title={"TEAM"} />
      <div className="intro">
        <p>
          Paulus J. Lee, the founding father of the Korean Game industry, was an early pioneer in game engines and 3D animation technology. He developed a method to render 3D
          graphics quickly on low-spec devices at scale.
        </p>
        <p>
          Together with a group of top-tier developers from SKKU, Seoul National University, KAIST, and Korea University, Paulus designed 3rd generation blockchain technology based
          on the novel <span className="bold">Proof of Nonce</span> consensus algorithm.
        </p>
        <p>
          Today we are proud to have an extraordinarily talented team of over 40 developers with a wealth of expertise in the gaming industry, cryptography, distributed systems.
        </p>
      </div>
      <div>
        <p className="bold">Ethos:</p>
        <p className="bold">Something Happened in Crypto</p>
        <p>
          In the early days, it was us versus the world.
          <br /> You could mine crypto with a home computer, securing the blockchain while earning. Bitcoin was the future of money, and Ethereum was the future of finance. Our
          friends and family didn’t understand yet, but we were all excited to be a part of it.
        </p>
        <p>
          In the next cycle, discovering new projects was easy on Twitter or Telegram. Projects created opportunity for early community members who often saw huge returns. Neo,
          Ripple, ADA, and BNB all experienced 5000x gains, benefiting the community, not the VCs.{" "}
        </p>
        <p>
          After the public sale, teams would build what they promised, increasing the user base and token price. Binance, the most successful crypto company ever, emerged from this
          model.
        </p>
        <p className="bold">Today</p>
        <p>
          Bitcoin is largely unusable and is mostly controlled by BlackRock. Ethereum has abandoned scaling efforts, leaving us inundated with countless layer 2s with terrible user
          experience. Layer 1 chains get VC investment of $100m+, offering little opportunity left for the community. This ultimately results in very little activity on their
          chains.
        </p>
        <p>VCs get a huge discount on new tokens, then they dump on you when you buy in. </p>
        <p>They only allow big companies set up validator nodes and extract the bulk of the yield. Then they set up MEV bots to steal money from you on every transaction. </p>
        <p className="bold">This isn’t fair.</p>
        <p>
          VERIA is different. We’re returning to the early days.
          <br />
          VERIA is a super-fast, EVM-compatible, anti-MEV 3rd generation Layer 1 proof-of-stake blockchain where anyone can easily become a validator and earn (mine) tokens.
        </p>
        <p>
          73% of all tokens will be rewarded to the community at about 9% apy. There will be a small presales modestly raising less than $15m so that we can build the tech and get
          the word out. There will be no massive VC allocations.
        </p>
        <p>We believe in creating opportunity for our community. If you believe in our vision, help us change the meta and put crypto back on course. </p>
        <p className="bold">Join the movement!</p>
      </div>
    </div>
  );
}

export default Section5;
